import {
  FilterInput
}  from 'src/services/graphql/Models';
import { DataClass } from 'src/shared/utility';

export default class Filter implements FilterInput, DataClass {
  typedId: string;
  unitIds?: Array< string > | null;
  unitGroups?: Array< string > | null;
  unitSensors?: Array< string > | null;
  
  constructor ( from: any ) {
    this.unitIds = from.unitIds;
    this.unitGroups = from.unitGroups;
    this.unitSensors = from.unitSensors;
  }
  
  filterSensor(unitSensorAlias: string, unit?: any) {
    let result: number = 0;

    if (this.unitIds.some(unitId => unitId === unit.typedId)) {
        result += 7;
    }

    if (
        unit.unitGroups.some(
            unitUnitGroup => this.unitGroups.some(
                filterUnitGroup => filterUnitGroup === unitUnitGroup
            )
        )
    ) {
        result += 3;
    }

    if (this.unitGroups.some(unitGroup => unitGroup === 'All Units')) {
        result += 1;
    }

    if (
        result !== 0 &&
        this.unitSensors.length > 0 &&
        this.unitSensors.some(unitSensor => unitSensor.length > 0)
    ) {  
        const lowerAlias = unitSensorAlias.toLowerCase();
        if (
            this.unitSensors.some(
                unitSensor => lowerAlias.includes(unitSensor)
            )
        ) {
            result += 15;
        } else {
            result = 0;
        }
    }

    return result;
  }
  
  parseAbsolute() {
    return {
        unitIds: this.unitIds.slice ? this.unitIds.slice() : [],
        unitGroups: this.unitGroups.slice ? this.unitGroups.slice() : [],
        unitSensors: this.unitSensors.slice ? this.unitSensors.slice() : []
    };
  }
}


// WEBPACK FOOTER //
// ./src/stores/application/classes/Filter.ts